import { SessionEntityKind } from '../session/enums.js';
import { SHORT_ID_PREFIX } from './enums.js';

// Longest-first so `rm` matches before `r` and a remark (`rm5`) is never
// read as a reflection (`r5`) plus a stray `m`.
const SHORT_ID_PREFIX_ALT = Object.values(SHORT_ID_PREFIX)
  .slice()
  .sort((a, b) => b.length - a.length)
  .join('|');

/**
 * Regex body (no anchors) for a single bare canonical short-id: a closed
 * prefix from `SHORT_ID_PREFIX` followed by a positive integer with no
 * leading zeros. Composable into larger patterns (e.g. the tool-protocol
 * `SID_VALUE` that also accepts `[[…]]` framing and version composites).
 *
 * Derived from `SHORT_ID_PREFIX` so adding a new entity kind only requires
 * updating that map.
 */
export const CANONICAL_SHORT_ID_BODY = `(?:${SHORT_ID_PREFIX_ALT})[1-9]\\d*`;

/** Anchored form of `CANONICAL_SHORT_ID_BODY` — use to validate a standalone sid. */
export const CANONICAL_SHORT_ID_REGEX = new RegExp(`^${CANONICAL_SHORT_ID_BODY}$`);

const POSITIVE_INT_BODY = '[1-9]\\d*';

/**
 * Regex body (no anchors) for every sid shape a RENDERED reference token may
 * carry: a bare canonical short-id, or the view-time version composite
 * (`p3/5`, `p3/latest`) that the FE resolver consumes transparently. The
 * composite arm leads so `p3/5` is never claimed as a bare `p3`.
 *
 * Kept in lockstep with the tool-protocol `SID_VALUE`, which spells the same
 * grammar for tool ARGUMENTS. This one governs prose: a renderer uses it to
 * decide whether a token is a reference or ordinary text.
 */
export const RENDERABLE_REF_BODY =
  `(?:${SHORT_ID_PREFIX[SessionEntityKind.Product]}${POSITIVE_INT_BODY}/(?:${POSITIVE_INT_BODY}|latest)`
  + `|${CANONICAL_SHORT_ID_BODY})`;
